import clsx from 'clsx'
import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import CloseIcon from '../../assets/img/ico-close.svg?react'
import LoupeIcon from '../../assets/img/ico-loupe.svg?react'
import MagnifyIcon from '../../assets/img/ico-magnify.svg?react'

const SearchForm: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const initialSearch = searchParams.get('search') || ''
    const [isSearchOpen, setIsSearchOpen] = useState(false)
    const [searchValue, setSearchValue] = useState(initialSearch)

    useEffect(() => {
        setSearchValue(initialSearch)
    }, [initialSearch])

    const handleSearchToggle = () => {
        setIsSearchOpen(!isSearchOpen)
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value)
    }

    const handleSearchSubmit = (event: React.FormEvent) => {
        event.preventDefault()
        const params = new URLSearchParams(searchParams)
        if (searchValue) {
            params.set('search', searchValue)
        } else {
            params.delete('search')
        }
        setSearchParams(params)
    }

    return (
        <form
            className={clsx('search-form', {
                '--show-search': isSearchOpen,
            })}
            onSubmit={handleSearchSubmit}
        >
            <div className="input-wrapper input--xl input--shadow search-form-row full-radius">
                <div className="search-form-toggler input-wrapper search-form-row input--shadow input--xl full-radius">
                    <button
                        type="submit"
                        className="btn text-color-1 search-btn"
                    >
                        <span className="ico">
                            <MagnifyIcon />
                        </span>
                    </button>
                    <input
                        className="input font-2"
                        type="text"
                        placeholder="Search information..."
                        value={searchValue}
                        onChange={handleInputChange}
                    />
                </div>
                <button
                    type="button"
                    className="btn btn-tool search-btn toggle-btn-search"
                    onClick={handleSearchToggle}
                >
                    <span className="ico --show">
                        <LoupeIcon />
                    </span>
                    <span className="ico --hide">
                        <CloseIcon />
                    </span>
                </button>
            </div>
        </form>
    )
}

export default SearchForm
